import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { Wrapper, Header, NameWrapper, Row, Column, ButtonSection, InfoLabel, InputName, NavButton } from './shared_details_form_styles';
import { addStudent } from '../actions/studentActions';
import styled from 'styled-components';

const RowOnCreateStudent = styled(Row)`
@media (max-width:600px) {
    flex-direction: column;
} 
`;

const ColumnOnCreateStudent = styled(Column)`
@media (max-width:600px) {
    width:90%;
} 
`;

export const CreateStudent = () => {


  const [name, setName] = useState("");
  const [document, setDocument] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [church, setChurch] = useState("");
  const [education_level, setEducationLevel] = useState("");
  const [age, setAge] = useState("");
  const [ocupation, setOcupation] = useState("");
  const [address, setAddress] = useState("");
  const [currency, setCurrency] = useState("UYU");
  const currencies =['UYU','ARG','USD'];
  const dispatch = useDispatch();

  function calculateAge(bdate) {
    const today = new Date();
    const birthdate = new Date(bdate);
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDiff = today.getMonth() - birthdate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdate.getDate())) {
      age--;
    }

    return age;
  }
  const handleSave = async () => {
    const input = {
      name,
      document,
      birthdate,
      city,
      phone,
      mail,
      church,
      education_level,
      ocupation,
      address,
      currency
    };
    dispatch(addStudent(input));
  };

  useEffect(() => {
    if (birthdate) {
      setAge(calculateAge(birthdate));
    }
  }, [birthdate])

  return (
    <Wrapper>
      <Header>
        <NameWrapper>
          <InputName
            type="text"
            name="name"
            placeholder='Name'
            value={name}
            onChange={(e) => { setName(e.target.value) }}
          />
        </NameWrapper>
      </Header>
      <RowOnCreateStudent>
        <ColumnOnCreateStudent>
          <Label>
            ID:
            <Input
              type="text"
              name="document"
              placeholder='ID'
              value={document}
              onChange={(e) => { setDocument(e.target.value) }}

            />
          </Label>
          <Label>
            Birthdate:
            <Input
              type="date"
              name="birthdate"
              placeholder='Birthdate'
              value={birthdate.split('T')[0]}
              onChange={(e) => { setBirthdate(e.target.value); setAge(calculateAge(birthdate)); }}

            />
          </Label>
          <Label>
            Email:
            <Input
              type="text"
              name="mail"
              placeholder='Email'
              value={mail}
              onChange={(e) => { setMail(e.target.value) }}

            />
          </Label>
          <Label>
            Phone:
            <Input
              type="text"
              name="phone"
              placeholder='Phone'
              value={phone}
              onChange={(e) => { setPhone(e.target.value) }}

            />
          </Label>
          <Label>
            Address:
            <Input
              type="text"
              name="address"
              placeholder='Address'
              value={address}
              onChange={(e) => { setAddress(e.target.value) }}

            />
          </Label>
          <Label>
              Currency of Payments:
                <Select
                    value={currency}
                    onChange={(e) => { setCurrency(e.target.value) }}
                >
                    {currencies.map((item, index) => (

                        <option key={index} value={item}>{item}</option>
                    ))}
                </Select>
            </Label>
        </ColumnOnCreateStudent>
        <ColumnOnCreateStudent>
          <Label>
            City:
            <Input
              type="text"
              name="city"
              placeholder='City'
              value={city}
              onChange={(e) => { setCity(e.target.value) }}

            />
          </Label>
          <Label>
            Age:
            <Input
              type="text"
              name="age"
              value={age ? age : ""}
              disabled
              islabel="true"
            />
          </Label>
          <Label>
            Church:
            <Input
              type="text"
              name="church"
              placeholder='Church'
              value={church}
              onChange={(e) => { setChurch(e.target.value) }}

            />
          </Label>
          <Label>
            Education level:
            <Input
              type="text"
              name="education_level"
              placeholder='Education level'
              value={education_level}
              onChange={(e) => { setEducationLevel(e.target.value) }}

            />
          </Label>
          <Label>
            Occupation:
            <Input
              type="text"
              name="ocupation"
              placeholder='Occupation'
              value={ocupation}
              onChange={(e) => { setOcupation(e.target.value) }}

            />
          </Label>

        </ColumnOnCreateStudent>
      </RowOnCreateStudent>

      {name != '' && document!='' && <Button style={{ width: '50%' }} onClick={()=>handleSave()}>Save</Button>}


    </Wrapper >
  );
};


export default CreateStudent;
